/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root";
import { Route as IndexRouteImport } from "./routes/index";
import { Route as AddressRouteImport } from "./routes/$address";
import { Route as ActivitiesRouteImport } from "./routes/activities";
import { Route as AdminRouteImport } from "./routes/admin";
import { Route as AgentRouteImport } from "./routes/agent";
import { Route as ConsoleRouteImport } from "./routes/console";
import { Route as KitRouteImport } from "./routes/kit";
import { Route as PricingRouteImport } from "./routes/pricing";
import { Route as PublishRouteImport } from "./routes/publish";
import { Route as PublisherRouteImport } from "./routes/publisher";
import { Route as SignInRouteImport } from "./routes/sign-in";
import { Route as AddressRoleRouteImport } from "./routes/$address_.$role";
import { Route as AdminIndexRouteImport } from "./routes/admin.index";
import { Route as AdminGrantsRouteImport } from "./routes/admin.grants";
import { Route as AdminRolesRouteImport } from "./routes/admin.roles";
import { Route as AgentCalibrationRouteImport } from "./routes/agent.calibration";
import { Route as AgentLocalSettingsRouteImport } from "./routes/agent.local-settings";
import { Route as AgentPairingRouteImport } from "./routes/agent.pairing";
import { Route as AgentStatusRouteImport } from "./routes/agent.status";
import { Route as ConsoleIndexRouteImport } from "./routes/console.index";
import { Route as ConsoleAccountRouteImport } from "./routes/console.account";
import { Route as ConsoleBillingRouteImport } from "./routes/console.billing";
import { Route as ConsoleFeedsRouteImport } from "./routes/console.feeds";
import { Route as ConsoleHomeRouteImport } from "./routes/console.home";
import { Route as ConsoleMachinesRouteImport } from "./routes/console.machines";
import { Route as ConsolePeopleRouteImport } from "./routes/console.people";
import { Route as ConsolePlanRouteImport } from "./routes/console.plan";
import { Route as DashboardIndexRouteImport } from "./routes/dashboard.index";
import { Route as DashboardCanvasRouteImport } from "./routes/dashboard.canvas";
import { Route as DashboardSpaceRouteImport } from "./routes/dashboard.space";
import { Route as HarnessRoleAssignmentsRouteImport } from "./routes/harness.role-assignments";
import { Route as ModChannelRouteImport } from "./routes/mod.$channel";
import { Route as PlayCodeRouteImport } from "./routes/play.$code";
import { Route as PublisherIndexRouteImport } from "./routes/publisher.index";
import { Route as PublisherListingRouteImport } from "./routes/publisher.listing";
import { Route as PublisherNamespaceRouteImport } from "./routes/publisher.namespace";
import { Route as PublisherTokensRouteImport } from "./routes/publisher.tokens";
import { Route as PublisherValidationRouteImport } from "./routes/publisher.validation";
import { Route as SCodeRouteImport } from "./routes/s.$code";
import { Route as SpaceCodeRouteImport } from "./routes/space.$code";
import { Route as UHandleRouteImport } from "./routes/u.$handle";
import { Route as ConsoleActivitiesIndexRouteImport } from "./routes/console.activities.index";
import { Route as ConsoleActivitiesActivityIdRouteImport } from "./routes/console.activities.$activityId";
import { Route as ConsoleMachinesIndexRouteImport } from "./routes/console.machines.index";
import { Route as ConsoleMachinesPairRouteImport } from "./routes/console.machines.pair";
import { Route as ConsoleSpacesIndexRouteImport } from "./routes/console.spaces.index";
import { Route as ConsoleSpacesJoinCodeRouteImport } from "./routes/console.spaces.$joinCode";
import { Route as ConsoleStudioIndexRouteImport } from "./routes/console.studio.index";
import { Route as ConsoleStudioDraftRouteImport } from "./routes/console.studio.$draft";
import { Route as DropDisplayStageMountRouteImport } from "./routes/drop.display.$stageMount";
import { Route as ShowDisplayStageMountRouteImport } from "./routes/show.display.$stageMount";
import { Route as ConsoleSpacesJoinCodeIndexRouteImport } from "./routes/console.spaces.$joinCode.index";
import { Route as ConsoleSpacesJoinCodeBindingsRouteImport } from "./routes/console.spaces.$joinCode.bindings";
import { Route as ConsoleSpacesJoinCodeCanvasesRouteImport } from "./routes/console.spaces.$joinCode.canvases";
import { Route as ConsoleSpacesJoinCodeControlRouteImport } from "./routes/console.spaces.$joinCode.control";
import { Route as ConsoleSpacesJoinCodePeopleRouteImport } from "./routes/console.spaces.$joinCode.people";
import { Route as ConsoleSpacesJoinCodeRunsRouteImport } from "./routes/console.spaces.$joinCode.runs";
import { Route as ConsoleSpacesJoinCodeSettingsRouteImport } from "./routes/console.spaces.$joinCode.settings";
import { Route as DropModeratorDropMountStageMountRouteImport } from "./routes/drop.moderator.$dropMount.$stageMount";
import { Route as HexDisplayChoiceMountBoardMountRouteImport } from "./routes/hex.display.$choiceMount.$boardMount";
import { Route as HexModeratorChoiceMountBoardMountRouteImport } from "./routes/hex.moderator.$choiceMount.$boardMount";
import { Route as HexViewerChoiceMountBoardMountRouteImport } from "./routes/hex.viewer.$choiceMount.$boardMount";
import { Route as ShowHostClockMountStageMountRouteImport } from "./routes/show.host.$clockMount.$stageMount";
import { Route as ShowViewerVoteMountStageMountRouteImport } from "./routes/show.viewer.$voteMount.$stageMount";
import { Route as ConsoleSpacesJoinCodeActivitiesAddedActivityRouteImport } from "./routes/console.spaces_.$joinCode.activities.$addedActivity";
import { Route as DropViewerDropMountPadMountEmoteMountRouteImport } from "./routes/drop.viewer.$dropMount.$padMount.$emoteMount";
import { Route as ShowContestantRaceMountSeatMountStageMountRouteImport } from "./routes/show.contestant.$raceMount.$seatMount.$stageMount";

const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any);
const AddressRoute = AddressRouteImport.update({
  id: "/$address",
  path: "/$address",
  getParentRoute: () => rootRouteImport,
} as any);
const ActivitiesRoute = ActivitiesRouteImport.update({
  id: "/activities",
  path: "/activities",
  getParentRoute: () => rootRouteImport,
} as any);
const AdminRoute = AdminRouteImport.update({
  id: "/admin",
  path: "/admin",
  getParentRoute: () => rootRouteImport,
} as any);
const AgentRoute = AgentRouteImport.update({
  id: "/agent",
  path: "/agent",
  getParentRoute: () => rootRouteImport,
} as any);
const ConsoleRoute = ConsoleRouteImport.update({
  id: "/console",
  path: "/console",
  getParentRoute: () => rootRouteImport,
} as any);
const KitRoute = KitRouteImport.update({
  id: "/kit",
  path: "/kit",
  getParentRoute: () => rootRouteImport,
} as any);
const PricingRoute = PricingRouteImport.update({
  id: "/pricing",
  path: "/pricing",
  getParentRoute: () => rootRouteImport,
} as any);
const PublishRoute = PublishRouteImport.update({
  id: "/publish",
  path: "/publish",
  getParentRoute: () => rootRouteImport,
} as any);
const PublisherRoute = PublisherRouteImport.update({
  id: "/publisher",
  path: "/publisher",
  getParentRoute: () => rootRouteImport,
} as any);
const SignInRoute = SignInRouteImport.update({
  id: "/sign-in",
  path: "/sign-in",
  getParentRoute: () => rootRouteImport,
} as any);
const AddressRoleRoute = AddressRoleRouteImport.update({
  id: "/$address_/$role",
  path: "/$address/$role",
  getParentRoute: () => rootRouteImport,
} as any);
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AdminRoute,
} as any);
const AdminGrantsRoute = AdminGrantsRouteImport.update({
  id: "/grants",
  path: "/grants",
  getParentRoute: () => AdminRoute,
} as any);
const AdminRolesRoute = AdminRolesRouteImport.update({
  id: "/roles",
  path: "/roles",
  getParentRoute: () => AdminRoute,
} as any);
const AgentCalibrationRoute = AgentCalibrationRouteImport.update({
  id: "/calibration",
  path: "/calibration",
  getParentRoute: () => AgentRoute,
} as any);
const AgentLocalSettingsRoute = AgentLocalSettingsRouteImport.update({
  id: "/local-settings",
  path: "/local-settings",
  getParentRoute: () => AgentRoute,
} as any);
const AgentPairingRoute = AgentPairingRouteImport.update({
  id: "/pairing",
  path: "/pairing",
  getParentRoute: () => AgentRoute,
} as any);
const AgentStatusRoute = AgentStatusRouteImport.update({
  id: "/status",
  path: "/status",
  getParentRoute: () => AgentRoute,
} as any);
const ConsoleIndexRoute = ConsoleIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => ConsoleRoute,
} as any);
const ConsoleAccountRoute = ConsoleAccountRouteImport.update({
  id: "/account",
  path: "/account",
  getParentRoute: () => ConsoleRoute,
} as any);
const ConsoleBillingRoute = ConsoleBillingRouteImport.update({
  id: "/billing",
  path: "/billing",
  getParentRoute: () => ConsoleRoute,
} as any);
const ConsoleFeedsRoute = ConsoleFeedsRouteImport.update({
  id: "/feeds",
  path: "/feeds",
  getParentRoute: () => ConsoleRoute,
} as any);
const ConsoleHomeRoute = ConsoleHomeRouteImport.update({
  id: "/home",
  path: "/home",
  getParentRoute: () => ConsoleRoute,
} as any);
const ConsoleMachinesRoute = ConsoleMachinesRouteImport.update({
  id: "/machines",
  path: "/machines",
  getParentRoute: () => ConsoleRoute,
} as any);
const ConsolePeopleRoute = ConsolePeopleRouteImport.update({
  id: "/people",
  path: "/people",
  getParentRoute: () => ConsoleRoute,
} as any);
const ConsolePlanRoute = ConsolePlanRouteImport.update({
  id: "/plan",
  path: "/plan",
  getParentRoute: () => ConsoleRoute,
} as any);
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: "/dashboard/",
  path: "/dashboard/",
  getParentRoute: () => rootRouteImport,
} as any);
const DashboardCanvasRoute = DashboardCanvasRouteImport.update({
  id: "/dashboard/canvas",
  path: "/dashboard/canvas",
  getParentRoute: () => rootRouteImport,
} as any);
const DashboardSpaceRoute = DashboardSpaceRouteImport.update({
  id: "/dashboard/space",
  path: "/dashboard/space",
  getParentRoute: () => rootRouteImport,
} as any);
const HarnessRoleAssignmentsRoute = HarnessRoleAssignmentsRouteImport.update({
  id: "/harness/role-assignments",
  path: "/harness/role-assignments",
  getParentRoute: () => rootRouteImport,
} as any);
const ModChannelRoute = ModChannelRouteImport.update({
  id: "/mod/$channel",
  path: "/mod/$channel",
  getParentRoute: () => rootRouteImport,
} as any);
const PlayCodeRoute = PlayCodeRouteImport.update({
  id: "/play/$code",
  path: "/play/$code",
  getParentRoute: () => rootRouteImport,
} as any);
const PublisherIndexRoute = PublisherIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => PublisherRoute,
} as any);
const PublisherListingRoute = PublisherListingRouteImport.update({
  id: "/listing",
  path: "/listing",
  getParentRoute: () => PublisherRoute,
} as any);
const PublisherNamespaceRoute = PublisherNamespaceRouteImport.update({
  id: "/namespace",
  path: "/namespace",
  getParentRoute: () => PublisherRoute,
} as any);
const PublisherTokensRoute = PublisherTokensRouteImport.update({
  id: "/tokens",
  path: "/tokens",
  getParentRoute: () => PublisherRoute,
} as any);
const PublisherValidationRoute = PublisherValidationRouteImport.update({
  id: "/validation",
  path: "/validation",
  getParentRoute: () => PublisherRoute,
} as any);
const SCodeRoute = SCodeRouteImport.update({
  id: "/s/$code",
  path: "/s/$code",
  getParentRoute: () => rootRouteImport,
} as any);
const SpaceCodeRoute = SpaceCodeRouteImport.update({
  id: "/space/$code",
  path: "/space/$code",
  getParentRoute: () => rootRouteImport,
} as any);
const UHandleRoute = UHandleRouteImport.update({
  id: "/u/$handle",
  path: "/u/$handle",
  getParentRoute: () => rootRouteImport,
} as any);
const ConsoleActivitiesIndexRoute = ConsoleActivitiesIndexRouteImport.update({
  id: "/activities/",
  path: "/activities/",
  getParentRoute: () => ConsoleRoute,
} as any);
const ConsoleActivitiesActivityIdRoute =
  ConsoleActivitiesActivityIdRouteImport.update({
    id: "/activities/$activityId",
    path: "/activities/$activityId",
    getParentRoute: () => ConsoleRoute,
  } as any);
const ConsoleMachinesIndexRoute = ConsoleMachinesIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => ConsoleMachinesRoute,
} as any);
const ConsoleMachinesPairRoute = ConsoleMachinesPairRouteImport.update({
  id: "/pair",
  path: "/pair",
  getParentRoute: () => ConsoleMachinesRoute,
} as any);
const ConsoleSpacesIndexRoute = ConsoleSpacesIndexRouteImport.update({
  id: "/spaces/",
  path: "/spaces/",
  getParentRoute: () => ConsoleRoute,
} as any);
const ConsoleSpacesJoinCodeRoute = ConsoleSpacesJoinCodeRouteImport.update({
  id: "/spaces/$joinCode",
  path: "/spaces/$joinCode",
  getParentRoute: () => ConsoleRoute,
} as any);
const ConsoleStudioIndexRoute = ConsoleStudioIndexRouteImport.update({
  id: "/studio/",
  path: "/studio/",
  getParentRoute: () => ConsoleRoute,
} as any);
const ConsoleStudioDraftRoute = ConsoleStudioDraftRouteImport.update({
  id: "/studio/$draft",
  path: "/studio/$draft",
  getParentRoute: () => ConsoleRoute,
} as any);
const DropDisplayStageMountRoute = DropDisplayStageMountRouteImport.update({
  id: "/drop/display/$stageMount",
  path: "/drop/display/$stageMount",
  getParentRoute: () => rootRouteImport,
} as any);
const ShowDisplayStageMountRoute = ShowDisplayStageMountRouteImport.update({
  id: "/show/display/$stageMount",
  path: "/show/display/$stageMount",
  getParentRoute: () => rootRouteImport,
} as any);
const ConsoleSpacesJoinCodeIndexRoute =
  ConsoleSpacesJoinCodeIndexRouteImport.update({
    id: "/",
    path: "/",
    getParentRoute: () => ConsoleSpacesJoinCodeRoute,
  } as any);
const ConsoleSpacesJoinCodeBindingsRoute =
  ConsoleSpacesJoinCodeBindingsRouteImport.update({
    id: "/bindings",
    path: "/bindings",
    getParentRoute: () => ConsoleSpacesJoinCodeRoute,
  } as any);
const ConsoleSpacesJoinCodeCanvasesRoute =
  ConsoleSpacesJoinCodeCanvasesRouteImport.update({
    id: "/canvases",
    path: "/canvases",
    getParentRoute: () => ConsoleSpacesJoinCodeRoute,
  } as any);
const ConsoleSpacesJoinCodeControlRoute =
  ConsoleSpacesJoinCodeControlRouteImport.update({
    id: "/control",
    path: "/control",
    getParentRoute: () => ConsoleSpacesJoinCodeRoute,
  } as any);
const ConsoleSpacesJoinCodePeopleRoute =
  ConsoleSpacesJoinCodePeopleRouteImport.update({
    id: "/people",
    path: "/people",
    getParentRoute: () => ConsoleSpacesJoinCodeRoute,
  } as any);
const ConsoleSpacesJoinCodeRunsRoute =
  ConsoleSpacesJoinCodeRunsRouteImport.update({
    id: "/runs",
    path: "/runs",
    getParentRoute: () => ConsoleSpacesJoinCodeRoute,
  } as any);
const ConsoleSpacesJoinCodeSettingsRoute =
  ConsoleSpacesJoinCodeSettingsRouteImport.update({
    id: "/settings",
    path: "/settings",
    getParentRoute: () => ConsoleSpacesJoinCodeRoute,
  } as any);
const DropModeratorDropMountStageMountRoute =
  DropModeratorDropMountStageMountRouteImport.update({
    id: "/drop/moderator/$dropMount/$stageMount",
    path: "/drop/moderator/$dropMount/$stageMount",
    getParentRoute: () => rootRouteImport,
  } as any);
const HexDisplayChoiceMountBoardMountRoute =
  HexDisplayChoiceMountBoardMountRouteImport.update({
    id: "/hex/display/$choiceMount/$boardMount",
    path: "/hex/display/$choiceMount/$boardMount",
    getParentRoute: () => rootRouteImport,
  } as any);
const HexModeratorChoiceMountBoardMountRoute =
  HexModeratorChoiceMountBoardMountRouteImport.update({
    id: "/hex/moderator/$choiceMount/$boardMount",
    path: "/hex/moderator/$choiceMount/$boardMount",
    getParentRoute: () => rootRouteImport,
  } as any);
const HexViewerChoiceMountBoardMountRoute =
  HexViewerChoiceMountBoardMountRouteImport.update({
    id: "/hex/viewer/$choiceMount/$boardMount",
    path: "/hex/viewer/$choiceMount/$boardMount",
    getParentRoute: () => rootRouteImport,
  } as any);
const ShowHostClockMountStageMountRoute =
  ShowHostClockMountStageMountRouteImport.update({
    id: "/show/host/$clockMount/$stageMount",
    path: "/show/host/$clockMount/$stageMount",
    getParentRoute: () => rootRouteImport,
  } as any);
const ShowViewerVoteMountStageMountRoute =
  ShowViewerVoteMountStageMountRouteImport.update({
    id: "/show/viewer/$voteMount/$stageMount",
    path: "/show/viewer/$voteMount/$stageMount",
    getParentRoute: () => rootRouteImport,
  } as any);
const ConsoleSpacesJoinCodeActivitiesAddedActivityRoute =
  ConsoleSpacesJoinCodeActivitiesAddedActivityRouteImport.update({
    id: "/spaces_/$joinCode/activities/$addedActivity",
    path: "/spaces/$joinCode/activities/$addedActivity",
    getParentRoute: () => ConsoleRoute,
  } as any);
const DropViewerDropMountPadMountEmoteMountRoute =
  DropViewerDropMountPadMountEmoteMountRouteImport.update({
    id: "/drop/viewer/$dropMount/$padMount/$emoteMount",
    path: "/drop/viewer/$dropMount/$padMount/$emoteMount",
    getParentRoute: () => rootRouteImport,
  } as any);
const ShowContestantRaceMountSeatMountStageMountRoute =
  ShowContestantRaceMountSeatMountStageMountRouteImport.update({
    id: "/show/contestant/$raceMount/$seatMount/$stageMount",
    path: "/show/contestant/$raceMount/$seatMount/$stageMount",
    getParentRoute: () => rootRouteImport,
  } as any);

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute;
  "/$address": typeof AddressRoute;
  "/activities": typeof ActivitiesRoute;
  "/admin": typeof AdminRouteWithChildren;
  "/agent": typeof AgentRouteWithChildren;
  "/console": typeof ConsoleRouteWithChildren;
  "/kit": typeof KitRoute;
  "/pricing": typeof PricingRoute;
  "/publish": typeof PublishRoute;
  "/publisher": typeof PublisherRouteWithChildren;
  "/sign-in": typeof SignInRoute;
  "/$address/$role": typeof AddressRoleRoute;
  "/admin/grants": typeof AdminGrantsRoute;
  "/admin/roles": typeof AdminRolesRoute;
  "/agent/calibration": typeof AgentCalibrationRoute;
  "/agent/local-settings": typeof AgentLocalSettingsRoute;
  "/agent/pairing": typeof AgentPairingRoute;
  "/agent/status": typeof AgentStatusRoute;
  "/console/account": typeof ConsoleAccountRoute;
  "/console/billing": typeof ConsoleBillingRoute;
  "/console/feeds": typeof ConsoleFeedsRoute;
  "/console/home": typeof ConsoleHomeRoute;
  "/console/machines": typeof ConsoleMachinesRouteWithChildren;
  "/console/people": typeof ConsolePeopleRoute;
  "/console/plan": typeof ConsolePlanRoute;
  "/dashboard/canvas": typeof DashboardCanvasRoute;
  "/dashboard/space": typeof DashboardSpaceRoute;
  "/harness/role-assignments": typeof HarnessRoleAssignmentsRoute;
  "/mod/$channel": typeof ModChannelRoute;
  "/play/$code": typeof PlayCodeRoute;
  "/publisher/listing": typeof PublisherListingRoute;
  "/publisher/namespace": typeof PublisherNamespaceRoute;
  "/publisher/tokens": typeof PublisherTokensRoute;
  "/publisher/validation": typeof PublisherValidationRoute;
  "/s/$code": typeof SCodeRoute;
  "/space/$code": typeof SpaceCodeRoute;
  "/u/$handle": typeof UHandleRoute;
  "/admin/": typeof AdminIndexRoute;
  "/console/": typeof ConsoleIndexRoute;
  "/dashboard/": typeof DashboardIndexRoute;
  "/publisher/": typeof PublisherIndexRoute;
  "/console/activities/$activityId": typeof ConsoleActivitiesActivityIdRoute;
  "/console/machines/pair": typeof ConsoleMachinesPairRoute;
  "/console/spaces/$joinCode": typeof ConsoleSpacesJoinCodeRouteWithChildren;
  "/console/studio/$draft": typeof ConsoleStudioDraftRoute;
  "/drop/display/$stageMount": typeof DropDisplayStageMountRoute;
  "/show/display/$stageMount": typeof ShowDisplayStageMountRoute;
  "/console/activities/": typeof ConsoleActivitiesIndexRoute;
  "/console/machines/": typeof ConsoleMachinesIndexRoute;
  "/console/spaces/": typeof ConsoleSpacesIndexRoute;
  "/console/studio/": typeof ConsoleStudioIndexRoute;
  "/console/spaces/$joinCode/bindings": typeof ConsoleSpacesJoinCodeBindingsRoute;
  "/console/spaces/$joinCode/canvases": typeof ConsoleSpacesJoinCodeCanvasesRoute;
  "/console/spaces/$joinCode/control": typeof ConsoleSpacesJoinCodeControlRoute;
  "/console/spaces/$joinCode/people": typeof ConsoleSpacesJoinCodePeopleRoute;
  "/console/spaces/$joinCode/runs": typeof ConsoleSpacesJoinCodeRunsRoute;
  "/console/spaces/$joinCode/settings": typeof ConsoleSpacesJoinCodeSettingsRoute;
  "/drop/moderator/$dropMount/$stageMount": typeof DropModeratorDropMountStageMountRoute;
  "/hex/display/$choiceMount/$boardMount": typeof HexDisplayChoiceMountBoardMountRoute;
  "/hex/moderator/$choiceMount/$boardMount": typeof HexModeratorChoiceMountBoardMountRoute;
  "/hex/viewer/$choiceMount/$boardMount": typeof HexViewerChoiceMountBoardMountRoute;
  "/show/host/$clockMount/$stageMount": typeof ShowHostClockMountStageMountRoute;
  "/show/viewer/$voteMount/$stageMount": typeof ShowViewerVoteMountStageMountRoute;
  "/console/spaces/$joinCode/": typeof ConsoleSpacesJoinCodeIndexRoute;
  "/console/spaces/$joinCode/activities/$addedActivity": typeof ConsoleSpacesJoinCodeActivitiesAddedActivityRoute;
  "/drop/viewer/$dropMount/$padMount/$emoteMount": typeof DropViewerDropMountPadMountEmoteMountRoute;
  "/show/contestant/$raceMount/$seatMount/$stageMount": typeof ShowContestantRaceMountSeatMountStageMountRoute;
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute;
  "/$address": typeof AddressRoute;
  "/activities": typeof ActivitiesRoute;
  "/agent": typeof AgentRouteWithChildren;
  "/kit": typeof KitRoute;
  "/pricing": typeof PricingRoute;
  "/publish": typeof PublishRoute;
  "/sign-in": typeof SignInRoute;
  "/$address/$role": typeof AddressRoleRoute;
  "/admin/grants": typeof AdminGrantsRoute;
  "/admin/roles": typeof AdminRolesRoute;
  "/agent/calibration": typeof AgentCalibrationRoute;
  "/agent/local-settings": typeof AgentLocalSettingsRoute;
  "/agent/pairing": typeof AgentPairingRoute;
  "/agent/status": typeof AgentStatusRoute;
  "/console/account": typeof ConsoleAccountRoute;
  "/console/billing": typeof ConsoleBillingRoute;
  "/console/feeds": typeof ConsoleFeedsRoute;
  "/console/home": typeof ConsoleHomeRoute;
  "/console/people": typeof ConsolePeopleRoute;
  "/console/plan": typeof ConsolePlanRoute;
  "/dashboard/canvas": typeof DashboardCanvasRoute;
  "/dashboard/space": typeof DashboardSpaceRoute;
  "/harness/role-assignments": typeof HarnessRoleAssignmentsRoute;
  "/mod/$channel": typeof ModChannelRoute;
  "/play/$code": typeof PlayCodeRoute;
  "/publisher/listing": typeof PublisherListingRoute;
  "/publisher/namespace": typeof PublisherNamespaceRoute;
  "/publisher/tokens": typeof PublisherTokensRoute;
  "/publisher/validation": typeof PublisherValidationRoute;
  "/s/$code": typeof SCodeRoute;
  "/space/$code": typeof SpaceCodeRoute;
  "/u/$handle": typeof UHandleRoute;
  "/admin": typeof AdminIndexRoute;
  "/console": typeof ConsoleIndexRoute;
  "/dashboard": typeof DashboardIndexRoute;
  "/publisher": typeof PublisherIndexRoute;
  "/console/activities/$activityId": typeof ConsoleActivitiesActivityIdRoute;
  "/console/machines/pair": typeof ConsoleMachinesPairRoute;
  "/console/studio/$draft": typeof ConsoleStudioDraftRoute;
  "/drop/display/$stageMount": typeof DropDisplayStageMountRoute;
  "/show/display/$stageMount": typeof ShowDisplayStageMountRoute;
  "/console/activities": typeof ConsoleActivitiesIndexRoute;
  "/console/machines": typeof ConsoleMachinesIndexRoute;
  "/console/spaces": typeof ConsoleSpacesIndexRoute;
  "/console/studio": typeof ConsoleStudioIndexRoute;
  "/console/spaces/$joinCode/bindings": typeof ConsoleSpacesJoinCodeBindingsRoute;
  "/console/spaces/$joinCode/canvases": typeof ConsoleSpacesJoinCodeCanvasesRoute;
  "/console/spaces/$joinCode/control": typeof ConsoleSpacesJoinCodeControlRoute;
  "/console/spaces/$joinCode/people": typeof ConsoleSpacesJoinCodePeopleRoute;
  "/console/spaces/$joinCode/runs": typeof ConsoleSpacesJoinCodeRunsRoute;
  "/console/spaces/$joinCode/settings": typeof ConsoleSpacesJoinCodeSettingsRoute;
  "/drop/moderator/$dropMount/$stageMount": typeof DropModeratorDropMountStageMountRoute;
  "/hex/display/$choiceMount/$boardMount": typeof HexDisplayChoiceMountBoardMountRoute;
  "/hex/moderator/$choiceMount/$boardMount": typeof HexModeratorChoiceMountBoardMountRoute;
  "/hex/viewer/$choiceMount/$boardMount": typeof HexViewerChoiceMountBoardMountRoute;
  "/show/host/$clockMount/$stageMount": typeof ShowHostClockMountStageMountRoute;
  "/show/viewer/$voteMount/$stageMount": typeof ShowViewerVoteMountStageMountRoute;
  "/console/spaces/$joinCode": typeof ConsoleSpacesJoinCodeIndexRoute;
  "/console/spaces/$joinCode/activities/$addedActivity": typeof ConsoleSpacesJoinCodeActivitiesAddedActivityRoute;
  "/drop/viewer/$dropMount/$padMount/$emoteMount": typeof DropViewerDropMountPadMountEmoteMountRoute;
  "/show/contestant/$raceMount/$seatMount/$stageMount": typeof ShowContestantRaceMountSeatMountStageMountRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/": typeof IndexRoute;
  "/$address": typeof AddressRoute;
  "/activities": typeof ActivitiesRoute;
  "/admin": typeof AdminRouteWithChildren;
  "/agent": typeof AgentRouteWithChildren;
  "/console": typeof ConsoleRouteWithChildren;
  "/kit": typeof KitRoute;
  "/pricing": typeof PricingRoute;
  "/publish": typeof PublishRoute;
  "/publisher": typeof PublisherRouteWithChildren;
  "/sign-in": typeof SignInRoute;
  "/$address_/$role": typeof AddressRoleRoute;
  "/admin/grants": typeof AdminGrantsRoute;
  "/admin/roles": typeof AdminRolesRoute;
  "/agent/calibration": typeof AgentCalibrationRoute;
  "/agent/local-settings": typeof AgentLocalSettingsRoute;
  "/agent/pairing": typeof AgentPairingRoute;
  "/agent/status": typeof AgentStatusRoute;
  "/console/account": typeof ConsoleAccountRoute;
  "/console/billing": typeof ConsoleBillingRoute;
  "/console/feeds": typeof ConsoleFeedsRoute;
  "/console/home": typeof ConsoleHomeRoute;
  "/console/machines": typeof ConsoleMachinesRouteWithChildren;
  "/console/people": typeof ConsolePeopleRoute;
  "/console/plan": typeof ConsolePlanRoute;
  "/dashboard/canvas": typeof DashboardCanvasRoute;
  "/dashboard/space": typeof DashboardSpaceRoute;
  "/harness/role-assignments": typeof HarnessRoleAssignmentsRoute;
  "/mod/$channel": typeof ModChannelRoute;
  "/play/$code": typeof PlayCodeRoute;
  "/publisher/listing": typeof PublisherListingRoute;
  "/publisher/namespace": typeof PublisherNamespaceRoute;
  "/publisher/tokens": typeof PublisherTokensRoute;
  "/publisher/validation": typeof PublisherValidationRoute;
  "/s/$code": typeof SCodeRoute;
  "/space/$code": typeof SpaceCodeRoute;
  "/u/$handle": typeof UHandleRoute;
  "/admin/": typeof AdminIndexRoute;
  "/console/": typeof ConsoleIndexRoute;
  "/dashboard/": typeof DashboardIndexRoute;
  "/publisher/": typeof PublisherIndexRoute;
  "/console/activities/$activityId": typeof ConsoleActivitiesActivityIdRoute;
  "/console/machines/pair": typeof ConsoleMachinesPairRoute;
  "/console/spaces/$joinCode": typeof ConsoleSpacesJoinCodeRouteWithChildren;
  "/console/studio/$draft": typeof ConsoleStudioDraftRoute;
  "/drop/display/$stageMount": typeof DropDisplayStageMountRoute;
  "/show/display/$stageMount": typeof ShowDisplayStageMountRoute;
  "/console/activities/": typeof ConsoleActivitiesIndexRoute;
  "/console/machines/": typeof ConsoleMachinesIndexRoute;
  "/console/spaces/": typeof ConsoleSpacesIndexRoute;
  "/console/studio/": typeof ConsoleStudioIndexRoute;
  "/console/spaces/$joinCode/bindings": typeof ConsoleSpacesJoinCodeBindingsRoute;
  "/console/spaces/$joinCode/canvases": typeof ConsoleSpacesJoinCodeCanvasesRoute;
  "/console/spaces/$joinCode/control": typeof ConsoleSpacesJoinCodeControlRoute;
  "/console/spaces/$joinCode/people": typeof ConsoleSpacesJoinCodePeopleRoute;
  "/console/spaces/$joinCode/runs": typeof ConsoleSpacesJoinCodeRunsRoute;
  "/console/spaces/$joinCode/settings": typeof ConsoleSpacesJoinCodeSettingsRoute;
  "/drop/moderator/$dropMount/$stageMount": typeof DropModeratorDropMountStageMountRoute;
  "/hex/display/$choiceMount/$boardMount": typeof HexDisplayChoiceMountBoardMountRoute;
  "/hex/moderator/$choiceMount/$boardMount": typeof HexModeratorChoiceMountBoardMountRoute;
  "/hex/viewer/$choiceMount/$boardMount": typeof HexViewerChoiceMountBoardMountRoute;
  "/show/host/$clockMount/$stageMount": typeof ShowHostClockMountStageMountRoute;
  "/show/viewer/$voteMount/$stageMount": typeof ShowViewerVoteMountStageMountRoute;
  "/console/spaces/$joinCode/": typeof ConsoleSpacesJoinCodeIndexRoute;
  "/console/spaces_/$joinCode/activities/$addedActivity": typeof ConsoleSpacesJoinCodeActivitiesAddedActivityRoute;
  "/drop/viewer/$dropMount/$padMount/$emoteMount": typeof DropViewerDropMountPadMountEmoteMountRoute;
  "/show/contestant/$raceMount/$seatMount/$stageMount": typeof ShowContestantRaceMountSeatMountStageMountRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/$address"
    | "/activities"
    | "/admin"
    | "/agent"
    | "/console"
    | "/kit"
    | "/pricing"
    | "/publish"
    | "/publisher"
    | "/sign-in"
    | "/$address/$role"
    | "/admin/grants"
    | "/admin/roles"
    | "/agent/calibration"
    | "/agent/local-settings"
    | "/agent/pairing"
    | "/agent/status"
    | "/console/account"
    | "/console/billing"
    | "/console/feeds"
    | "/console/home"
    | "/console/machines"
    | "/console/people"
    | "/console/plan"
    | "/dashboard/canvas"
    | "/dashboard/space"
    | "/harness/role-assignments"
    | "/mod/$channel"
    | "/play/$code"
    | "/publisher/listing"
    | "/publisher/namespace"
    | "/publisher/tokens"
    | "/publisher/validation"
    | "/s/$code"
    | "/space/$code"
    | "/u/$handle"
    | "/admin/"
    | "/console/"
    | "/dashboard/"
    | "/publisher/"
    | "/console/activities/$activityId"
    | "/console/machines/pair"
    | "/console/spaces/$joinCode"
    | "/console/studio/$draft"
    | "/drop/display/$stageMount"
    | "/show/display/$stageMount"
    | "/console/activities/"
    | "/console/machines/"
    | "/console/spaces/"
    | "/console/studio/"
    | "/console/spaces/$joinCode/bindings"
    | "/console/spaces/$joinCode/canvases"
    | "/console/spaces/$joinCode/control"
    | "/console/spaces/$joinCode/people"
    | "/console/spaces/$joinCode/runs"
    | "/console/spaces/$joinCode/settings"
    | "/drop/moderator/$dropMount/$stageMount"
    | "/hex/display/$choiceMount/$boardMount"
    | "/hex/moderator/$choiceMount/$boardMount"
    | "/hex/viewer/$choiceMount/$boardMount"
    | "/show/host/$clockMount/$stageMount"
    | "/show/viewer/$voteMount/$stageMount"
    | "/console/spaces/$joinCode/"
    | "/console/spaces/$joinCode/activities/$addedActivity"
    | "/drop/viewer/$dropMount/$padMount/$emoteMount"
    | "/show/contestant/$raceMount/$seatMount/$stageMount";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/$address"
    | "/activities"
    | "/agent"
    | "/kit"
    | "/pricing"
    | "/publish"
    | "/sign-in"
    | "/$address/$role"
    | "/admin/grants"
    | "/admin/roles"
    | "/agent/calibration"
    | "/agent/local-settings"
    | "/agent/pairing"
    | "/agent/status"
    | "/console/account"
    | "/console/billing"
    | "/console/feeds"
    | "/console/home"
    | "/console/people"
    | "/console/plan"
    | "/dashboard/canvas"
    | "/dashboard/space"
    | "/harness/role-assignments"
    | "/mod/$channel"
    | "/play/$code"
    | "/publisher/listing"
    | "/publisher/namespace"
    | "/publisher/tokens"
    | "/publisher/validation"
    | "/s/$code"
    | "/space/$code"
    | "/u/$handle"
    | "/admin"
    | "/console"
    | "/dashboard"
    | "/publisher"
    | "/console/activities/$activityId"
    | "/console/machines/pair"
    | "/console/studio/$draft"
    | "/drop/display/$stageMount"
    | "/show/display/$stageMount"
    | "/console/activities"
    | "/console/machines"
    | "/console/spaces"
    | "/console/studio"
    | "/console/spaces/$joinCode/bindings"
    | "/console/spaces/$joinCode/canvases"
    | "/console/spaces/$joinCode/control"
    | "/console/spaces/$joinCode/people"
    | "/console/spaces/$joinCode/runs"
    | "/console/spaces/$joinCode/settings"
    | "/drop/moderator/$dropMount/$stageMount"
    | "/hex/display/$choiceMount/$boardMount"
    | "/hex/moderator/$choiceMount/$boardMount"
    | "/hex/viewer/$choiceMount/$boardMount"
    | "/show/host/$clockMount/$stageMount"
    | "/show/viewer/$voteMount/$stageMount"
    | "/console/spaces/$joinCode"
    | "/console/spaces/$joinCode/activities/$addedActivity"
    | "/drop/viewer/$dropMount/$padMount/$emoteMount"
    | "/show/contestant/$raceMount/$seatMount/$stageMount";
  id:
    | "__root__"
    | "/"
    | "/$address"
    | "/activities"
    | "/admin"
    | "/agent"
    | "/console"
    | "/kit"
    | "/pricing"
    | "/publish"
    | "/publisher"
    | "/sign-in"
    | "/$address_/$role"
    | "/admin/grants"
    | "/admin/roles"
    | "/agent/calibration"
    | "/agent/local-settings"
    | "/agent/pairing"
    | "/agent/status"
    | "/console/account"
    | "/console/billing"
    | "/console/feeds"
    | "/console/home"
    | "/console/machines"
    | "/console/people"
    | "/console/plan"
    | "/dashboard/canvas"
    | "/dashboard/space"
    | "/harness/role-assignments"
    | "/mod/$channel"
    | "/play/$code"
    | "/publisher/listing"
    | "/publisher/namespace"
    | "/publisher/tokens"
    | "/publisher/validation"
    | "/s/$code"
    | "/space/$code"
    | "/u/$handle"
    | "/admin/"
    | "/console/"
    | "/dashboard/"
    | "/publisher/"
    | "/console/activities/$activityId"
    | "/console/machines/pair"
    | "/console/spaces/$joinCode"
    | "/console/studio/$draft"
    | "/drop/display/$stageMount"
    | "/show/display/$stageMount"
    | "/console/activities/"
    | "/console/machines/"
    | "/console/spaces/"
    | "/console/studio/"
    | "/console/spaces/$joinCode/bindings"
    | "/console/spaces/$joinCode/canvases"
    | "/console/spaces/$joinCode/control"
    | "/console/spaces/$joinCode/people"
    | "/console/spaces/$joinCode/runs"
    | "/console/spaces/$joinCode/settings"
    | "/drop/moderator/$dropMount/$stageMount"
    | "/hex/display/$choiceMount/$boardMount"
    | "/hex/moderator/$choiceMount/$boardMount"
    | "/hex/viewer/$choiceMount/$boardMount"
    | "/show/host/$clockMount/$stageMount"
    | "/show/viewer/$voteMount/$stageMount"
    | "/console/spaces/$joinCode/"
    | "/console/spaces_/$joinCode/activities/$addedActivity"
    | "/drop/viewer/$dropMount/$padMount/$emoteMount"
    | "/show/contestant/$raceMount/$seatMount/$stageMount";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AddressRoute: typeof AddressRoute;
  ActivitiesRoute: typeof ActivitiesRoute;
  AdminRoute: typeof AdminRouteWithChildren;
  AgentRoute: typeof AgentRouteWithChildren;
  ConsoleRoute: typeof ConsoleRouteWithChildren;
  KitRoute: typeof KitRoute;
  PricingRoute: typeof PricingRoute;
  PublishRoute: typeof PublishRoute;
  PublisherRoute: typeof PublisherRouteWithChildren;
  SignInRoute: typeof SignInRoute;
  AddressRoleRoute: typeof AddressRoleRoute;
  DashboardCanvasRoute: typeof DashboardCanvasRoute;
  DashboardSpaceRoute: typeof DashboardSpaceRoute;
  HarnessRoleAssignmentsRoute: typeof HarnessRoleAssignmentsRoute;
  ModChannelRoute: typeof ModChannelRoute;
  PlayCodeRoute: typeof PlayCodeRoute;
  SCodeRoute: typeof SCodeRoute;
  SpaceCodeRoute: typeof SpaceCodeRoute;
  UHandleRoute: typeof UHandleRoute;
  DashboardIndexRoute: typeof DashboardIndexRoute;
  DropDisplayStageMountRoute: typeof DropDisplayStageMountRoute;
  ShowDisplayStageMountRoute: typeof ShowDisplayStageMountRoute;
  DropModeratorDropMountStageMountRoute: typeof DropModeratorDropMountStageMountRoute;
  HexDisplayChoiceMountBoardMountRoute: typeof HexDisplayChoiceMountBoardMountRoute;
  HexModeratorChoiceMountBoardMountRoute: typeof HexModeratorChoiceMountBoardMountRoute;
  HexViewerChoiceMountBoardMountRoute: typeof HexViewerChoiceMountBoardMountRoute;
  ShowHostClockMountStageMountRoute: typeof ShowHostClockMountStageMountRoute;
  ShowViewerVoteMountStageMountRoute: typeof ShowViewerVoteMountStageMountRoute;
  DropViewerDropMountPadMountEmoteMountRoute: typeof DropViewerDropMountPadMountEmoteMountRoute;
  ShowContestantRaceMountSeatMountStageMountRoute: typeof ShowContestantRaceMountSeatMountStageMountRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/$address": {
      id: "/$address";
      path: "/$address";
      fullPath: "/$address";
      preLoaderRoute: typeof AddressRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/activities": {
      id: "/activities";
      path: "/activities";
      fullPath: "/activities";
      preLoaderRoute: typeof ActivitiesRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/admin": {
      id: "/admin";
      path: "/admin";
      fullPath: "/admin";
      preLoaderRoute: typeof AdminRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/agent": {
      id: "/agent";
      path: "/agent";
      fullPath: "/agent";
      preLoaderRoute: typeof AgentRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/console": {
      id: "/console";
      path: "/console";
      fullPath: "/console";
      preLoaderRoute: typeof ConsoleRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/kit": {
      id: "/kit";
      path: "/kit";
      fullPath: "/kit";
      preLoaderRoute: typeof KitRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/pricing": {
      id: "/pricing";
      path: "/pricing";
      fullPath: "/pricing";
      preLoaderRoute: typeof PricingRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/publish": {
      id: "/publish";
      path: "/publish";
      fullPath: "/publish";
      preLoaderRoute: typeof PublishRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/publisher": {
      id: "/publisher";
      path: "/publisher";
      fullPath: "/publisher";
      preLoaderRoute: typeof PublisherRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/sign-in": {
      id: "/sign-in";
      path: "/sign-in";
      fullPath: "/sign-in";
      preLoaderRoute: typeof SignInRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/$address_/$role": {
      id: "/$address_/$role";
      path: "/$address/$role";
      fullPath: "/$address/$role";
      preLoaderRoute: typeof AddressRoleRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/admin/": {
      id: "/admin/";
      path: "/";
      fullPath: "/admin/";
      preLoaderRoute: typeof AdminIndexRouteImport;
      parentRoute: typeof AdminRoute;
    };
    "/admin/grants": {
      id: "/admin/grants";
      path: "/grants";
      fullPath: "/admin/grants";
      preLoaderRoute: typeof AdminGrantsRouteImport;
      parentRoute: typeof AdminRoute;
    };
    "/admin/roles": {
      id: "/admin/roles";
      path: "/roles";
      fullPath: "/admin/roles";
      preLoaderRoute: typeof AdminRolesRouteImport;
      parentRoute: typeof AdminRoute;
    };
    "/agent/calibration": {
      id: "/agent/calibration";
      path: "/calibration";
      fullPath: "/agent/calibration";
      preLoaderRoute: typeof AgentCalibrationRouteImport;
      parentRoute: typeof AgentRoute;
    };
    "/agent/local-settings": {
      id: "/agent/local-settings";
      path: "/local-settings";
      fullPath: "/agent/local-settings";
      preLoaderRoute: typeof AgentLocalSettingsRouteImport;
      parentRoute: typeof AgentRoute;
    };
    "/agent/pairing": {
      id: "/agent/pairing";
      path: "/pairing";
      fullPath: "/agent/pairing";
      preLoaderRoute: typeof AgentPairingRouteImport;
      parentRoute: typeof AgentRoute;
    };
    "/agent/status": {
      id: "/agent/status";
      path: "/status";
      fullPath: "/agent/status";
      preLoaderRoute: typeof AgentStatusRouteImport;
      parentRoute: typeof AgentRoute;
    };
    "/console/": {
      id: "/console/";
      path: "/";
      fullPath: "/console/";
      preLoaderRoute: typeof ConsoleIndexRouteImport;
      parentRoute: typeof ConsoleRoute;
    };
    "/console/account": {
      id: "/console/account";
      path: "/account";
      fullPath: "/console/account";
      preLoaderRoute: typeof ConsoleAccountRouteImport;
      parentRoute: typeof ConsoleRoute;
    };
    "/console/billing": {
      id: "/console/billing";
      path: "/billing";
      fullPath: "/console/billing";
      preLoaderRoute: typeof ConsoleBillingRouteImport;
      parentRoute: typeof ConsoleRoute;
    };
    "/console/feeds": {
      id: "/console/feeds";
      path: "/feeds";
      fullPath: "/console/feeds";
      preLoaderRoute: typeof ConsoleFeedsRouteImport;
      parentRoute: typeof ConsoleRoute;
    };
    "/console/home": {
      id: "/console/home";
      path: "/home";
      fullPath: "/console/home";
      preLoaderRoute: typeof ConsoleHomeRouteImport;
      parentRoute: typeof ConsoleRoute;
    };
    "/console/machines": {
      id: "/console/machines";
      path: "/machines";
      fullPath: "/console/machines";
      preLoaderRoute: typeof ConsoleMachinesRouteImport;
      parentRoute: typeof ConsoleRoute;
    };
    "/console/people": {
      id: "/console/people";
      path: "/people";
      fullPath: "/console/people";
      preLoaderRoute: typeof ConsolePeopleRouteImport;
      parentRoute: typeof ConsoleRoute;
    };
    "/console/plan": {
      id: "/console/plan";
      path: "/plan";
      fullPath: "/console/plan";
      preLoaderRoute: typeof ConsolePlanRouteImport;
      parentRoute: typeof ConsoleRoute;
    };
    "/dashboard/": {
      id: "/dashboard/";
      path: "/dashboard";
      fullPath: "/dashboard/";
      preLoaderRoute: typeof DashboardIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/dashboard/canvas": {
      id: "/dashboard/canvas";
      path: "/dashboard/canvas";
      fullPath: "/dashboard/canvas";
      preLoaderRoute: typeof DashboardCanvasRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/dashboard/space": {
      id: "/dashboard/space";
      path: "/dashboard/space";
      fullPath: "/dashboard/space";
      preLoaderRoute: typeof DashboardSpaceRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/harness/role-assignments": {
      id: "/harness/role-assignments";
      path: "/harness/role-assignments";
      fullPath: "/harness/role-assignments";
      preLoaderRoute: typeof HarnessRoleAssignmentsRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/mod/$channel": {
      id: "/mod/$channel";
      path: "/mod/$channel";
      fullPath: "/mod/$channel";
      preLoaderRoute: typeof ModChannelRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/play/$code": {
      id: "/play/$code";
      path: "/play/$code";
      fullPath: "/play/$code";
      preLoaderRoute: typeof PlayCodeRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/publisher/": {
      id: "/publisher/";
      path: "/";
      fullPath: "/publisher/";
      preLoaderRoute: typeof PublisherIndexRouteImport;
      parentRoute: typeof PublisherRoute;
    };
    "/publisher/listing": {
      id: "/publisher/listing";
      path: "/listing";
      fullPath: "/publisher/listing";
      preLoaderRoute: typeof PublisherListingRouteImport;
      parentRoute: typeof PublisherRoute;
    };
    "/publisher/namespace": {
      id: "/publisher/namespace";
      path: "/namespace";
      fullPath: "/publisher/namespace";
      preLoaderRoute: typeof PublisherNamespaceRouteImport;
      parentRoute: typeof PublisherRoute;
    };
    "/publisher/tokens": {
      id: "/publisher/tokens";
      path: "/tokens";
      fullPath: "/publisher/tokens";
      preLoaderRoute: typeof PublisherTokensRouteImport;
      parentRoute: typeof PublisherRoute;
    };
    "/publisher/validation": {
      id: "/publisher/validation";
      path: "/validation";
      fullPath: "/publisher/validation";
      preLoaderRoute: typeof PublisherValidationRouteImport;
      parentRoute: typeof PublisherRoute;
    };
    "/s/$code": {
      id: "/s/$code";
      path: "/s/$code";
      fullPath: "/s/$code";
      preLoaderRoute: typeof SCodeRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/space/$code": {
      id: "/space/$code";
      path: "/space/$code";
      fullPath: "/space/$code";
      preLoaderRoute: typeof SpaceCodeRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/u/$handle": {
      id: "/u/$handle";
      path: "/u/$handle";
      fullPath: "/u/$handle";
      preLoaderRoute: typeof UHandleRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/console/activities/": {
      id: "/console/activities/";
      path: "/activities";
      fullPath: "/console/activities/";
      preLoaderRoute: typeof ConsoleActivitiesIndexRouteImport;
      parentRoute: typeof ConsoleRoute;
    };
    "/console/activities/$activityId": {
      id: "/console/activities/$activityId";
      path: "/activities/$activityId";
      fullPath: "/console/activities/$activityId";
      preLoaderRoute: typeof ConsoleActivitiesActivityIdRouteImport;
      parentRoute: typeof ConsoleRoute;
    };
    "/console/machines/": {
      id: "/console/machines/";
      path: "/";
      fullPath: "/console/machines/";
      preLoaderRoute: typeof ConsoleMachinesIndexRouteImport;
      parentRoute: typeof ConsoleMachinesRoute;
    };
    "/console/machines/pair": {
      id: "/console/machines/pair";
      path: "/pair";
      fullPath: "/console/machines/pair";
      preLoaderRoute: typeof ConsoleMachinesPairRouteImport;
      parentRoute: typeof ConsoleMachinesRoute;
    };
    "/console/spaces/": {
      id: "/console/spaces/";
      path: "/spaces";
      fullPath: "/console/spaces/";
      preLoaderRoute: typeof ConsoleSpacesIndexRouteImport;
      parentRoute: typeof ConsoleRoute;
    };
    "/console/spaces/$joinCode": {
      id: "/console/spaces/$joinCode";
      path: "/spaces/$joinCode";
      fullPath: "/console/spaces/$joinCode";
      preLoaderRoute: typeof ConsoleSpacesJoinCodeRouteImport;
      parentRoute: typeof ConsoleRoute;
    };
    "/console/studio/": {
      id: "/console/studio/";
      path: "/studio";
      fullPath: "/console/studio/";
      preLoaderRoute: typeof ConsoleStudioIndexRouteImport;
      parentRoute: typeof ConsoleRoute;
    };
    "/console/studio/$draft": {
      id: "/console/studio/$draft";
      path: "/studio/$draft";
      fullPath: "/console/studio/$draft";
      preLoaderRoute: typeof ConsoleStudioDraftRouteImport;
      parentRoute: typeof ConsoleRoute;
    };
    "/drop/display/$stageMount": {
      id: "/drop/display/$stageMount";
      path: "/drop/display/$stageMount";
      fullPath: "/drop/display/$stageMount";
      preLoaderRoute: typeof DropDisplayStageMountRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/show/display/$stageMount": {
      id: "/show/display/$stageMount";
      path: "/show/display/$stageMount";
      fullPath: "/show/display/$stageMount";
      preLoaderRoute: typeof ShowDisplayStageMountRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/console/spaces/$joinCode/": {
      id: "/console/spaces/$joinCode/";
      path: "/";
      fullPath: "/console/spaces/$joinCode/";
      preLoaderRoute: typeof ConsoleSpacesJoinCodeIndexRouteImport;
      parentRoute: typeof ConsoleSpacesJoinCodeRoute;
    };
    "/console/spaces/$joinCode/bindings": {
      id: "/console/spaces/$joinCode/bindings";
      path: "/bindings";
      fullPath: "/console/spaces/$joinCode/bindings";
      preLoaderRoute: typeof ConsoleSpacesJoinCodeBindingsRouteImport;
      parentRoute: typeof ConsoleSpacesJoinCodeRoute;
    };
    "/console/spaces/$joinCode/canvases": {
      id: "/console/spaces/$joinCode/canvases";
      path: "/canvases";
      fullPath: "/console/spaces/$joinCode/canvases";
      preLoaderRoute: typeof ConsoleSpacesJoinCodeCanvasesRouteImport;
      parentRoute: typeof ConsoleSpacesJoinCodeRoute;
    };
    "/console/spaces/$joinCode/control": {
      id: "/console/spaces/$joinCode/control";
      path: "/control";
      fullPath: "/console/spaces/$joinCode/control";
      preLoaderRoute: typeof ConsoleSpacesJoinCodeControlRouteImport;
      parentRoute: typeof ConsoleSpacesJoinCodeRoute;
    };
    "/console/spaces/$joinCode/people": {
      id: "/console/spaces/$joinCode/people";
      path: "/people";
      fullPath: "/console/spaces/$joinCode/people";
      preLoaderRoute: typeof ConsoleSpacesJoinCodePeopleRouteImport;
      parentRoute: typeof ConsoleSpacesJoinCodeRoute;
    };
    "/console/spaces/$joinCode/runs": {
      id: "/console/spaces/$joinCode/runs";
      path: "/runs";
      fullPath: "/console/spaces/$joinCode/runs";
      preLoaderRoute: typeof ConsoleSpacesJoinCodeRunsRouteImport;
      parentRoute: typeof ConsoleSpacesJoinCodeRoute;
    };
    "/console/spaces/$joinCode/settings": {
      id: "/console/spaces/$joinCode/settings";
      path: "/settings";
      fullPath: "/console/spaces/$joinCode/settings";
      preLoaderRoute: typeof ConsoleSpacesJoinCodeSettingsRouteImport;
      parentRoute: typeof ConsoleSpacesJoinCodeRoute;
    };
    "/drop/moderator/$dropMount/$stageMount": {
      id: "/drop/moderator/$dropMount/$stageMount";
      path: "/drop/moderator/$dropMount/$stageMount";
      fullPath: "/drop/moderator/$dropMount/$stageMount";
      preLoaderRoute: typeof DropModeratorDropMountStageMountRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/hex/display/$choiceMount/$boardMount": {
      id: "/hex/display/$choiceMount/$boardMount";
      path: "/hex/display/$choiceMount/$boardMount";
      fullPath: "/hex/display/$choiceMount/$boardMount";
      preLoaderRoute: typeof HexDisplayChoiceMountBoardMountRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/hex/moderator/$choiceMount/$boardMount": {
      id: "/hex/moderator/$choiceMount/$boardMount";
      path: "/hex/moderator/$choiceMount/$boardMount";
      fullPath: "/hex/moderator/$choiceMount/$boardMount";
      preLoaderRoute: typeof HexModeratorChoiceMountBoardMountRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/hex/viewer/$choiceMount/$boardMount": {
      id: "/hex/viewer/$choiceMount/$boardMount";
      path: "/hex/viewer/$choiceMount/$boardMount";
      fullPath: "/hex/viewer/$choiceMount/$boardMount";
      preLoaderRoute: typeof HexViewerChoiceMountBoardMountRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/show/host/$clockMount/$stageMount": {
      id: "/show/host/$clockMount/$stageMount";
      path: "/show/host/$clockMount/$stageMount";
      fullPath: "/show/host/$clockMount/$stageMount";
      preLoaderRoute: typeof ShowHostClockMountStageMountRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/show/viewer/$voteMount/$stageMount": {
      id: "/show/viewer/$voteMount/$stageMount";
      path: "/show/viewer/$voteMount/$stageMount";
      fullPath: "/show/viewer/$voteMount/$stageMount";
      preLoaderRoute: typeof ShowViewerVoteMountStageMountRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/console/spaces_/$joinCode/activities/$addedActivity": {
      id: "/console/spaces_/$joinCode/activities/$addedActivity";
      path: "/spaces/$joinCode/activities/$addedActivity";
      fullPath: "/console/spaces/$joinCode/activities/$addedActivity";
      preLoaderRoute: typeof ConsoleSpacesJoinCodeActivitiesAddedActivityRouteImport;
      parentRoute: typeof ConsoleRoute;
    };
    "/drop/viewer/$dropMount/$padMount/$emoteMount": {
      id: "/drop/viewer/$dropMount/$padMount/$emoteMount";
      path: "/drop/viewer/$dropMount/$padMount/$emoteMount";
      fullPath: "/drop/viewer/$dropMount/$padMount/$emoteMount";
      preLoaderRoute: typeof DropViewerDropMountPadMountEmoteMountRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/show/contestant/$raceMount/$seatMount/$stageMount": {
      id: "/show/contestant/$raceMount/$seatMount/$stageMount";
      path: "/show/contestant/$raceMount/$seatMount/$stageMount";
      fullPath: "/show/contestant/$raceMount/$seatMount/$stageMount";
      preLoaderRoute: typeof ShowContestantRaceMountSeatMountStageMountRouteImport;
      parentRoute: typeof rootRouteImport;
    };
  }
}

interface AdminRouteChildren {
  AdminGrantsRoute: typeof AdminGrantsRoute;
  AdminRolesRoute: typeof AdminRolesRoute;
  AdminIndexRoute: typeof AdminIndexRoute;
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminGrantsRoute: AdminGrantsRoute,
  AdminRolesRoute: AdminRolesRoute,
  AdminIndexRoute: AdminIndexRoute,
};

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren);

interface AgentRouteChildren {
  AgentCalibrationRoute: typeof AgentCalibrationRoute;
  AgentLocalSettingsRoute: typeof AgentLocalSettingsRoute;
  AgentPairingRoute: typeof AgentPairingRoute;
  AgentStatusRoute: typeof AgentStatusRoute;
}

const AgentRouteChildren: AgentRouteChildren = {
  AgentCalibrationRoute: AgentCalibrationRoute,
  AgentLocalSettingsRoute: AgentLocalSettingsRoute,
  AgentPairingRoute: AgentPairingRoute,
  AgentStatusRoute: AgentStatusRoute,
};

const AgentRouteWithChildren = AgentRoute._addFileChildren(AgentRouteChildren);

interface ConsoleMachinesRouteChildren {
  ConsoleMachinesPairRoute: typeof ConsoleMachinesPairRoute;
  ConsoleMachinesIndexRoute: typeof ConsoleMachinesIndexRoute;
}

const ConsoleMachinesRouteChildren: ConsoleMachinesRouteChildren = {
  ConsoleMachinesPairRoute: ConsoleMachinesPairRoute,
  ConsoleMachinesIndexRoute: ConsoleMachinesIndexRoute,
};

const ConsoleMachinesRouteWithChildren = ConsoleMachinesRoute._addFileChildren(
  ConsoleMachinesRouteChildren,
);

interface ConsoleSpacesJoinCodeRouteChildren {
  ConsoleSpacesJoinCodeBindingsRoute: typeof ConsoleSpacesJoinCodeBindingsRoute;
  ConsoleSpacesJoinCodeCanvasesRoute: typeof ConsoleSpacesJoinCodeCanvasesRoute;
  ConsoleSpacesJoinCodeControlRoute: typeof ConsoleSpacesJoinCodeControlRoute;
  ConsoleSpacesJoinCodePeopleRoute: typeof ConsoleSpacesJoinCodePeopleRoute;
  ConsoleSpacesJoinCodeRunsRoute: typeof ConsoleSpacesJoinCodeRunsRoute;
  ConsoleSpacesJoinCodeSettingsRoute: typeof ConsoleSpacesJoinCodeSettingsRoute;
  ConsoleSpacesJoinCodeIndexRoute: typeof ConsoleSpacesJoinCodeIndexRoute;
}

const ConsoleSpacesJoinCodeRouteChildren: ConsoleSpacesJoinCodeRouteChildren = {
  ConsoleSpacesJoinCodeBindingsRoute: ConsoleSpacesJoinCodeBindingsRoute,
  ConsoleSpacesJoinCodeCanvasesRoute: ConsoleSpacesJoinCodeCanvasesRoute,
  ConsoleSpacesJoinCodeControlRoute: ConsoleSpacesJoinCodeControlRoute,
  ConsoleSpacesJoinCodePeopleRoute: ConsoleSpacesJoinCodePeopleRoute,
  ConsoleSpacesJoinCodeRunsRoute: ConsoleSpacesJoinCodeRunsRoute,
  ConsoleSpacesJoinCodeSettingsRoute: ConsoleSpacesJoinCodeSettingsRoute,
  ConsoleSpacesJoinCodeIndexRoute: ConsoleSpacesJoinCodeIndexRoute,
};

const ConsoleSpacesJoinCodeRouteWithChildren =
  ConsoleSpacesJoinCodeRoute._addFileChildren(
    ConsoleSpacesJoinCodeRouteChildren,
  );

interface ConsoleRouteChildren {
  ConsoleAccountRoute: typeof ConsoleAccountRoute;
  ConsoleBillingRoute: typeof ConsoleBillingRoute;
  ConsoleFeedsRoute: typeof ConsoleFeedsRoute;
  ConsoleHomeRoute: typeof ConsoleHomeRoute;
  ConsoleMachinesRoute: typeof ConsoleMachinesRouteWithChildren;
  ConsolePeopleRoute: typeof ConsolePeopleRoute;
  ConsolePlanRoute: typeof ConsolePlanRoute;
  ConsoleIndexRoute: typeof ConsoleIndexRoute;
  ConsoleActivitiesActivityIdRoute: typeof ConsoleActivitiesActivityIdRoute;
  ConsoleSpacesJoinCodeRoute: typeof ConsoleSpacesJoinCodeRouteWithChildren;
  ConsoleStudioDraftRoute: typeof ConsoleStudioDraftRoute;
  ConsoleActivitiesIndexRoute: typeof ConsoleActivitiesIndexRoute;
  ConsoleSpacesIndexRoute: typeof ConsoleSpacesIndexRoute;
  ConsoleStudioIndexRoute: typeof ConsoleStudioIndexRoute;
  ConsoleSpacesJoinCodeActivitiesAddedActivityRoute: typeof ConsoleSpacesJoinCodeActivitiesAddedActivityRoute;
}

const ConsoleRouteChildren: ConsoleRouteChildren = {
  ConsoleAccountRoute: ConsoleAccountRoute,
  ConsoleBillingRoute: ConsoleBillingRoute,
  ConsoleFeedsRoute: ConsoleFeedsRoute,
  ConsoleHomeRoute: ConsoleHomeRoute,
  ConsoleMachinesRoute: ConsoleMachinesRouteWithChildren,
  ConsolePeopleRoute: ConsolePeopleRoute,
  ConsolePlanRoute: ConsolePlanRoute,
  ConsoleIndexRoute: ConsoleIndexRoute,
  ConsoleActivitiesActivityIdRoute: ConsoleActivitiesActivityIdRoute,
  ConsoleSpacesJoinCodeRoute: ConsoleSpacesJoinCodeRouteWithChildren,
  ConsoleStudioDraftRoute: ConsoleStudioDraftRoute,
  ConsoleActivitiesIndexRoute: ConsoleActivitiesIndexRoute,
  ConsoleSpacesIndexRoute: ConsoleSpacesIndexRoute,
  ConsoleStudioIndexRoute: ConsoleStudioIndexRoute,
  ConsoleSpacesJoinCodeActivitiesAddedActivityRoute:
    ConsoleSpacesJoinCodeActivitiesAddedActivityRoute,
};

const ConsoleRouteWithChildren =
  ConsoleRoute._addFileChildren(ConsoleRouteChildren);

interface PublisherRouteChildren {
  PublisherListingRoute: typeof PublisherListingRoute;
  PublisherNamespaceRoute: typeof PublisherNamespaceRoute;
  PublisherTokensRoute: typeof PublisherTokensRoute;
  PublisherValidationRoute: typeof PublisherValidationRoute;
  PublisherIndexRoute: typeof PublisherIndexRoute;
}

const PublisherRouteChildren: PublisherRouteChildren = {
  PublisherListingRoute: PublisherListingRoute,
  PublisherNamespaceRoute: PublisherNamespaceRoute,
  PublisherTokensRoute: PublisherTokensRoute,
  PublisherValidationRoute: PublisherValidationRoute,
  PublisherIndexRoute: PublisherIndexRoute,
};

const PublisherRouteWithChildren = PublisherRoute._addFileChildren(
  PublisherRouteChildren,
);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AddressRoute: AddressRoute,
  ActivitiesRoute: ActivitiesRoute,
  AdminRoute: AdminRouteWithChildren,
  AgentRoute: AgentRouteWithChildren,
  ConsoleRoute: ConsoleRouteWithChildren,
  KitRoute: KitRoute,
  PricingRoute: PricingRoute,
  PublishRoute: PublishRoute,
  PublisherRoute: PublisherRouteWithChildren,
  SignInRoute: SignInRoute,
  AddressRoleRoute: AddressRoleRoute,
  DashboardCanvasRoute: DashboardCanvasRoute,
  DashboardSpaceRoute: DashboardSpaceRoute,
  HarnessRoleAssignmentsRoute: HarnessRoleAssignmentsRoute,
  ModChannelRoute: ModChannelRoute,
  PlayCodeRoute: PlayCodeRoute,
  SCodeRoute: SCodeRoute,
  SpaceCodeRoute: SpaceCodeRoute,
  UHandleRoute: UHandleRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  DropDisplayStageMountRoute: DropDisplayStageMountRoute,
  ShowDisplayStageMountRoute: ShowDisplayStageMountRoute,
  DropModeratorDropMountStageMountRoute: DropModeratorDropMountStageMountRoute,
  HexDisplayChoiceMountBoardMountRoute: HexDisplayChoiceMountBoardMountRoute,
  HexModeratorChoiceMountBoardMountRoute:
    HexModeratorChoiceMountBoardMountRoute,
  HexViewerChoiceMountBoardMountRoute: HexViewerChoiceMountBoardMountRoute,
  ShowHostClockMountStageMountRoute: ShowHostClockMountStageMountRoute,
  ShowViewerVoteMountStageMountRoute: ShowViewerVoteMountStageMountRoute,
  DropViewerDropMountPadMountEmoteMountRoute:
    DropViewerDropMountPadMountEmoteMountRoute,
  ShowContestantRaceMountSeatMountStageMountRoute:
    ShowContestantRaceMountSeatMountStageMountRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
